<script>
import PrintComponent from './PrintComponent.vue';

export default {
    name: 'PrintMain',
    props:[
        "data",
        "subsId", 
        "reference",
        "modalopen",
        "type"
    ],
    components: {
        PrintComponent
    },
    data() {
        return {
            invoice: false,
            receipt: false,
            invoice_name: '',
            invoice_num: '',
            invoice_qty: '1',
            invoice_desc: '',
            receipt_name: '',
            receipt_num: '',
            receipt_qty: '1',
            receipt_desc: '',
            invoice_data: [],
            receipt_data: [],
            submitted: false,
            dataIds: [],
            datas: {},
            subscription: {},
            pay_detail: {},
            title: ''
        };
    }, 
    watch:{
        modalopen(){
            this.invoice= false
            this.receipt= false
            this.invoice_name= ''
            this.invoice_num= ''
            this.invoice_qty= '1'
            this.invoice_desc= ''
            this.receipt_name= ''
            this.receipt_num= ''
            this.receipt_qty= '1'
            this.receipt_desc= ''
            this.invoice_data= []
            this.receipt_data= []
            this.dataIds=[]
            this.datas={}
            this.subscription={}
        
            this.dataIds = this.data
            this.getInvoice()
        },
    },
    methods: {
        getInvoice(){
            this.$http.post('/balances', { ids: this.dataIds })
            .then(response => {
          
                let invoice_data = []
                let receipt_data = []

                response.data.map(e=>{
                    if(e.direction == 2){
                        invoice_data.push({id: e.id, amount: e.amount})
                    }

                    if(e.direction == 1){
                        receipt_data.push({id: e.id, amount: e.amount })
                        this.pay_detail = { payment_type_title: e.payment_type_title || null, user_name:e.user_name }
                    }
                })

                this.invoice = invoice_data.length > 0
                this.receipt = receipt_data.length > 0

                this.receipt_data = receipt_data
                this.invoice_data = invoice_data
            })

            this.$http.get('/members/' + this.subsId)
            .then(response => {
                this.invoice_name = response.data.fname + ' ' + response.data.lname
                this.receipt_name = response.data.fname + ' ' + response.data.lname
                this.subscription = response.data
            })
        },
        invoicePrint(){
            let invoice = {   
                invoice_num: this.invoice_num,
                invoice_data:this.invoice_data, 
                invoice_name: this.invoice_name, 
                invoice_qty: this.invoice_qty, 
                invoice_desc: this.invoice_desc, 
                receipt_data:this.receipt_data, 
                receipt_num: this.receipt_num,
                receipt_name: this.receipt_name,
                receipt_qty: this.receipt_qty,
                receipt_desc: this.receipt_desc,
                pay_detail: this.pay_detail,
                type: this.type,
                subs: this.subscription
            }
            
            this.$http.post('/balances', { ids: this.dataIds, print: true, invoice_num: this.type == 'makbuz' ? this.receipt_num : this.invoice_num });

            this.$refs.printComponent.print(invoice);
        },
        close(){
            this.$parent.$bvModal.hide('print_modal')
        },
    },
};
</script>

<template>
<b-modal id="print_modal" :title="`Makbuz / Fatura Yazdır`" size="lg" no-close-on-backdrop hide-footer>
    <div class="row d-flex flex-wrap mb-1" v-if="type=='fatura'">
        <label class="col-sm-5 col-form-label col-form-label" for="invoice_num1"><span>Fatura Numarası</span></label>
        <div class="col">
            <input
            id="invoice_num1" 
            v-model="invoice_num"
            type="text"
            class="form-control"
            />
        </div>
    </div>
    <div class="row d-flex flex-wrap mb-1" v-if="type=='fatura'">
        <label class="col-sm-5 col-form-label col-form-label" for="receipt_name"><span>Fatura İsmi</span></label>
        <div class="col">
            <input
            id="receipt_name" 
            v-model="invoice_name"
            type="text"
            class="form-control"
            />
        </div>
    </div>

     <div class="row d-flex flex-wrap mb-1" v-if="type=='fatura'">
        <label class="col-sm-5 col-form-label col-form-label" for="invoice_qty"><span>Miktar</span></label>
        <div class="col">
            <input
            id="invoice_qty" 
            v-model="invoice_qty"
            type="text"
            class="form-control"
            />
        </div>
    </div>

    <div class="row d-flex flex-wrap mb-1" v-if="type=='fatura'">
        <label class="col-sm-5 col-form-label col-form-label" for="invoice_desc"><span>Açıklama</span></label>
        <div class="col">
            <input
            id="invoice_desc" 
            v-model="invoice_desc"
            type="text"
            class="form-control"
            />
        </div>
    </div>

    <hr>
     <div class="row d-flex flex-wrap mb-1"  v-if="type=='makbuz'">
        <label class="col-sm-5 col-form-label col-form-label" for="receipt_num"><span>Makbuz Numarası</span></label>
        <div class="col">
            <input
            id="receipt_num" 
            v-model="receipt_num"
            type="text"
            class="form-control"
            />
        </div>
    </div>
    <div class="row d-flex flex-wrap mb-1"  v-if="type=='makbuz'">
        <label class="col-sm-5 col-form-label col-form-label" for="name"><span>Makbuz İsmi</span></label>
        <div class="col">
            <input
            id="name" 
            v-model="receipt_name"
            type="text"
            class="form-control"
            />
        </div>
    </div>
      <div class="row d-flex flex-wrap mb-1"  v-if="type=='makbuz'">
        <label class="col-sm-5 col-form-label col-form-label" for="receipt_qty"><span>Miktar</span></label>
        <div class="col">
            <input
            id="receipt_qty" 
            v-model="receipt_qty"
            type="text"
            class="form-control"
            />
        </div>
    </div>

    <div class="row d-flex flex-wrap mb-1"  v-if="type=='makbuz'">
        <label class="col-sm-5 col-form-label col-form-label" for="receipt_desc"><span>Açıklama</span></label>
        <div class="col">
            <input
            id="receipt_desc" 
            v-model="receipt_desc"
            type="text"
            class="form-control"
            />
        </div>
    </div>

    <div class="d-flex justify-content-between mt-3">
        <b-button variant="light" @click="close()">Vazgeç</b-button>
        <b-button 
            type="submit" 
            @click="invoicePrint()"
            variant="success" 
            class="ms-1"
            >Makbuz / Fatura Bas
        </b-button>
    </div>
    <PrintComponent ref="printComponent" />
</b-modal>
</template>